import React, { Dispatch, SetStateAction } from "react";
import Button from "../../atoms/button/button";
import FormInputAceleradora from "../../atoms/form-input-aceleradora/FormInputAceleradora";
import "./FormBottomAceleradora.scss";
import rawToReact from "../../../utils/rawToReact";
import { BLOCKS } from "@contentful/rich-text-types";

interface IBottomFormAceleradora {
    titleButton: string;
    activeWizard?: boolean;
    setActiveIndex: Dispatch<SetStateAction<number>>;
    activeIndex: number;
    inputs: any;
    endIndex: number;
    validateRequired: any;
    inputsErrorList: any;
    setInputValue: any;
    formValues: any;
    handleSubmitForm: any;
    isDisabled?: boolean;
    handleEvent?: any;
    dateState?: any;
    talleresData?: any;
    flagGTM?: string;
    handleCancelButton?: any;
    handleAuthorizationMigP?: any;
    handleAuthorizationMigI?: any;
    flagBotonVolver?: boolean;
    handleBigCancelButton?: any;
}

const FormBottomAceleradora = (props: IBottomFormAceleradora) => {
    const {
        titleButton,
        setActiveIndex,
        activeIndex,
        inputs,
        endIndex,
        validateRequired,
        setInputValue,
        handleSubmitForm,
        formValues,
        isDisabled,
        handleEvent,
        dateState,
        talleresData,
        flagGTM,
        handleCancelButton,
        handleAuthorizationMigP,
        handleAuthorizationMigI,
        flagBotonVolver,
        handleBigCancelButton
    } = props;

    const contentfulRenderOptionsMigD = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p>{children}
                    <a
                        style={{ color: "#EE2B7B" }}
                        href={"https://serviciosenlinea.comfama.com/webinicio/tratamientodatos.htm"}
                        target={"_blank"}
                        rel={"noopener noreferrer"}
                    >
                        &nbsp;aquí
                    </a>
                </p>;
            }
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };

    const contentfulRenderOptionsMigP = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p>{children}
                    <Button
                        type="button"
                        classname={`data-authorization-modal`}
                        text="aquí"
                        isDisabled={false}
                        onClickAction={handleAuthorizationMigP}
                    ></Button>
                </p>;
            }
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };

    const contentfulRenderOptionsMigI = {
        renderNode: {
            [BLOCKS.PARAGRAPH]: (node, children) => {
                return <p>{children}
                    <Button
                        type="button"
                        classname={`data-authorization-modal`}
                        text="aquí"
                        isDisabled={false}
                        onClickAction={handleAuthorizationMigI}
                    ></Button>
                </p>;
            }
        },
        renderText: (text) =>
            text.split("\n").flatMap((text, i) => [i > 0 && <br />, text]),
    };

    // Cuando se hace click en el boton continuar se validan los campos requeridos
    // en caso de que  alguno no este diligenciado muestra el error y no continua.
    const handleClick = () => {
        const currentIndex = activeIndex + 1;

        if(handleEvent != undefined){
            handleEvent(); 
        }

        validateRequired();

        if (validateRequired().length === 0) {
            if (currentIndex < endIndex) {
                setActiveIndex(currentIndex);
            } else {
                handleSubmitForm();
            }
        }
    };
    
    return (
        <div className={`m-form-bottom-aceleradora${handleBigCancelButton ? "__formContactar" : ""}`}>
            {/* Renderiza el campo para la autorizacion de datos. */}
            {inputs.map((input, index) => {
                if (input.nombreId === "dataProcessingAuthorization") {
                    return (
                        <>
                            {input.tituloBotonTerminos && (
                                <div className="m-form-bottom-aceleradora__authorization">
                                    <div
                                        className={
                                            "m-form-bottom-aceleradora__authorization__texto-terminos"
                                        }
                                    >
                                        {/* renderiza los terminos para la autorizacion de datos. */}
                                        {rawToReact(
                                            input.textoTerminos.raw,
                                            contentfulRenderOptionsMigD
                                        )}
                                    </div>
                                    {/* Renderiza el checkbox para la autorizacion de datos */}
                                    <div className="m-form-bottom-aceleradora__authorization__checkbox">
                                        <FormInputAceleradora
                                            key={index}
                                            title={""}
                                            errorMessage={input.mensajeError}
                                            value={""}
                                            nombreId={input.nombreId}
                                            textoTerminos=""
                                            type={input.tipoCampo}
                                            setInputValue={setInputValue}
                                            isError={
                                                props.inputsErrorList.indexOf(
                                                    input.nombreId
                                                ) !== -1
                                            }
                                            tituloBotonTerminos={
                                                input.tituloBotonTerminos
                                            }
                                            checked={
                                                formValues[input.nombreId]
                                                    ? true
                                                    : false
                                            }
                                            dateState={dateState}
                                            ayuda={input.ayuda}
                                            talleresData={talleresData}
                                        ></FormInputAceleradora>
                                    </div>
                                </div>
                            )}
                        </>
                    );
                }
                if (input.nombreId === "dataProcessingAuthorizationProgram") {
                    return (
                        <>
                            {input.tituloBotonTerminos && (
                                <div className="m-form-bottom-aceleradora__authorization-program">
                                    <div
                                        className={
                                            "m-form-bottom-aceleradora__authorization-program__texto-terminos"
                                        }
                                    >
                                        {/* renderiza los terminos para la autorizacion de datos. */}
                                        {rawToReact(
                                            input.textoTerminos.raw,
                                            contentfulRenderOptionsMigP
                                        )}                                        
                                    </div>
                                    {/* Renderiza el checkbox para la autorizacion de datos */}
                                    <div className="m-form-bottom-aceleradora__authorization-program__checkbox">
                                        <FormInputAceleradora
                                            key={index}
                                            title={""}
                                            errorMessage={input.mensajeError}
                                            value={""}
                                            nombreId={input.nombreId}
                                            textoTerminos=""
                                            type={input.tipoCampo}
                                            setInputValue={setInputValue}
                                            isError={
                                                props.inputsErrorList.indexOf(
                                                    input.nombreId
                                                ) !== -1
                                            }
                                            tituloBotonTerminos={
                                                input.tituloBotonTerminos
                                            }
                                            checked={
                                                formValues[input.nombreId]
                                                    ? true
                                                    : false
                                            }
                                            dateState={dateState}
                                            ayuda={input.ayuda}
                                            talleresData={talleresData}
                                        ></FormInputAceleradora>
                                    </div>
                                </div>
                            )}
                        </>
                    );
                }
                if (input.nombreId === "dataImageAuthorization") {
                    return (
                        <>
                            {input.tituloBotonTerminos && (
                                <div className="m-form-bottom-aceleradora__authorization-image">
                                    <div
                                        className={
                                            "m-form-bottom-aceleradora__authorization-image__texto-terminos"
                                        }
                                    >
                                        {/* renderiza los terminos para la autorizacion de datos. */}
                                        {rawToReact(
                                            input.textoTerminos.raw,
                                            contentfulRenderOptionsMigI
                                        )}
                                    </div>
                                    {/* Renderiza el checkbox para la autorizacion de datos */}
                                    <div className="m-form-bottom-aceleradora__authorization-image__checkbox">
                                        <FormInputAceleradora
                                            key={index}
                                            title={""}
                                            errorMessage={input.mensajeError}
                                            value={""}
                                            nombreId={input.nombreId}
                                            textoTerminos=""
                                            type={input.tipoCampo}
                                            setInputValue={setInputValue}
                                            isError={
                                                props.inputsErrorList.indexOf(
                                                    input.nombreId
                                                ) !== -1
                                            }
                                            tituloBotonTerminos={
                                                input.tituloBotonTerminos
                                            }
                                            checked={
                                                formValues[input.nombreId]
                                                    ? true
                                                    : false
                                            }
                                            dateState={dateState}
                                            ayuda={input.ayuda}
                                            talleresData={talleresData}
                                        ></FormInputAceleradora>
                                    </div>
                                </div>
                            )}
                        </>
                    );
                }
            })}

            {/* Si el wizard esta activo, se renderiza el boton VOLVER */}
            <div className="m-form-bottom-aceleradora__navigation">
                {handleCancelButton && (
                    <>
                        <Button
                            type="button"
                            classname={`gtmFormButton-cancel a-button big center btn__cancelar__aceleradora`}
                            text="Cancelar"
                            isDisabled={false}
                            onClickAction={handleCancelButton}
                        ></Button>
                    </>
                )}
                <div className={`botonesMigrantesMobile__aceleradora`}>
                    {handleCancelButton && flagBotonVolver && (
                        <>
                            <Button
                                type="button"
                                classname={`a-button__magenta-modal-aceleradora big center  ${activeIndex===0 && "bottom-disable-back"}`}
                                text="Volver"
                                isDisabled={activeIndex === 0}
                                onClickAction={() => {
                                    setActiveIndex(activeIndex - 1)
                                    document.querySelector(".m-form-migrantes-wizard")?.scrollIntoView();
                                }}
                            ></Button>
                        </>
                    )}
                    
                    {/*Boton de cancelar grande se renderiza si se recibe handleBigCancelButton como propiedad*/}
                    {handleBigCancelButton && (
                        <Button
                            type="button"
                            classname={`m-form-bottom-aceleradora__navigation-button-back`}
                            text={'Cancelar'}
                            isDisabled={false}
                            onClickAction={handleBigCancelButton}
                        ></Button>  

                    )}
                           
                    {/* Boton CONTINUAR/FINALIZAR siempre se renderiza */}
                    <>
                        <Button
                            type="button"
                            classname={`a-button__magenta_aceleradora big center ${titleButton === "Finalizar" ? `gtm${flagGTM}` : ""}`}
                            text={titleButton}
                            isDisabled={isDisabled}
                            onClickAction={handleClick}
                        ></Button>
                    </>
                </div>
            </div>
        </div>
    );
};

export default FormBottomAceleradora;
